import React from 'react'
import project from '../../project'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import axios from 'axios';
import Select from 'react-select'
import "../assets/styles/home.scss"
const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/AFLschedule2026/prod/AFLschedule2026.json'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstInteraction: false,
      data: [], // undefined,
      roundOptions: [
        { "value": "All", "label": "All Rounds" },
        { "value": "0", "label": "Round 0" },
        { "value": "1", "label": "Round 1" },
        { "value": "2", "label": "Round 2" },
        { "value": "3", "label": "Round 3" },
        { "value": "4", "label": "Round 4" },
        { "value": "5", "label": "Round 5" },
        { "value": "6", "label": "Round 6" },
        { "value": "7", "label": "Round 7" },
        { "value": "8", "label": "Round 8" },
        { "value": "9", "label": "Round 9" },
        { "value": "10", "label": "Round 10" },
        { "value": "11", "label": "Round 11" },
        { "value": "12", "label": "Round 12" },
        { "value": "13", "label": "Round 13" },
        { "value": "14", "label": "Round 14" },
        { "value": "15", "label": "Round 15" },
        { "value": "16", "label": "Round 16" },
        { "value": "17", "label": "Round 17" },
        { "value": "18", "label": "Round 18" },
        { "value": "19", "label": "Round 19" },
        { "value": "20", "label": "Round 20" },
        { "value": "21", "label": "Round 21" },
        { "value": "22", "label": "Round 22" },
        { "value": "23", "label": "Round 23" },
        { "value": "24", "label": "Round 24" }
      ],
      filteredData: [],
      filteredDataLong: false,
      selectedRound: { "value": "All", "label": "All Rounds" },
      selectedTeam: { label: "All Teams", value: "All" },
      selectedVenue: { label: "All Venues", value: "All" },
      venueOptions: [
        { "value": "All", "label": "All Venues" }
      ],
      selectedSort: 'round',
      selectedSortDirection: 'asc',
      teamOptions: [
        { "value": "All", "label": "All Teams" },
        { "value": "Adelaide", "label": "Adelaide" },
        { "value": "Brisbane Lions", "label": "Brisbane Lions" },
        { "value": "Carlton", "label": "Carlton" },
        { "value": "Collingwood", "label": "Collingwood" },
        { "value": "Essendon", "label": "Essendon" },
        { "value": "Fremantle", "label": "Fremantle" },
        { "value": "Geelong", "label": "Geelong" },
        { "value": "Gold Coast SUNS", "label": "Gold Coast SUNS" },
        { "value": "GWS Giants", "label": "GWS Giants" },
        { "value": "Hawthorn", "label": "Hawthorn" },
        { "value": "Melbourne", "label": "Melbourne" },
        { "value": "North Melbourne", "label": "North Melbourne" },
        { "value": "Port Adelaide", "label": "Port Adelaide" },
        { "value": "Richmond", "label": "Richmond" },
        { "value": "St Kilda", "label": "St Kilda" },
        { "value": "Sydney Swans", "label": "Sydney Swans" },
        { "value": "West Coast", "label": "West Coast" },
        { "value": "Western Bulldogs", "label": "Western Bulldogs" }
      ],
      // preselect: null,
      activeCard: null,
      // screenWidth: window.innerWidth,
      siteDomain: window.location.hostname.replace('www.','').replace('.com.au',''), //  codesports
      isMobApp: false
    }

    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.setState({ firstInteraction: true })
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })

    // const screenWidth = window.innerWidth;
    // console.log("Screen width: ", screenWidth, " pixels");
    
  }

  componentDidMount () {
    this.checkPreselect()
    this.loadData()
  }

  checkPreselect() {
    const appContainer = document.getElementById(`app_${project.name}`)
    const preselect = appContainer ? appContainer.getAttribute('data-preselect') : null
    
    if (preselect) {
      // Check if preselect value matches any team in teamOptions
      const matchedTeam = this.state.teamOptions.find(
        team => team.value.toLowerCase() === preselect.toLowerCase()
      )
      
      if (matchedTeam) {
        this.setState({
          selectedTeam: matchedTeam
        })
      }
    }
  }

  visChange (isVisible) {
    if ( isVisible && this.state.appInViewport === false) {
      this.setState({ appInViewport: true })
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  loadData () {
    
    fetch(apiURL_storage)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const titlesRemoved = data.values.length ? data.values.slice(1) : [];
        const cleanData = titlesRemoved.filter((card) => card.length);
        
        // Transform data
        const dataPaired = cleanData.map((game, index) => ({
          id: index,
          round: parseInt(game[0], 10),
          teamHome: game[1] ? game[1] : '',
          teamHomeClass: game[1] ? game[1].replaceAll(' ', '-') : '',
          teamAway: game[2] ? game[2] : '',
          teamAwayClass: game[2] ? game[2].replaceAll(' ', '-') : '',
          date: game[3] ? game[3] : '',
          time: game[4] ? game[4] : '',
          venue: game[5] ? game[5] : '',
          bye: game[6] ? game[6] : '',
        }));

        // Extract unique venues
        const uniqueVenues = [...new Set(dataPaired.map(game => game.venue).filter(venue => venue && venue !== ''))];
        const venueOptions = [
          { "value": "All", "label": "All Venues" },
          ...uniqueVenues.sort().map(venue => ({ "value": venue, "label": venue }))
        ];

        const dataSorted = this.sortByKey(dataPaired, this.state.selectedSort, this.state.selectedSortDirection);
        const isMobApp = !['mobile', 'desktop'].includes(document.body.getAttribute('data-device'));
        this.setState({ data: dataSorted, isMobApp, venueOptions }, this.filterList);
      })
      .catch((error) => {
        console.error('Error fetching data:', error)
        this.setState({ 
          data: [],
          filteredData: [],
          error: 'Failed to load schedule data. Please try again later.'
        })
      });

  }

  changeRound (e) {
    this.setState({
      selectedRound: e
    }, () => {
      this.filterList()
    })
    
  }

  changeSport (e) {
    const team = e
    this.setState({
      selectedTeam: team
    }, () => {
      this.filterList()
    })
  }

  changeVenue (e) {
    this.setState({
      selectedVenue: e
    }, () => {
      this.filterList()
    })
  }

  filterList () {
    const filteredList = this.state.data.filter((record) => {
      const roundMatch = this.state.selectedRound.value === 'All' || this.state.selectedRound.value == record.round
      const teamMatch = this.state.selectedTeam.value === 'All' || 
                        this.state.selectedTeam.value === record.teamHome || 
                        this.state.selectedTeam.value === record.teamAway
      const venueMatch = this.state.selectedVenue.value === 'All' || 
                         this.state.selectedVenue.value === record.venue
      
      return roundMatch && teamMatch && venueMatch
    })

    const isfilteredDataLong = filteredList.length > 20

    this.setState({
      filteredData: filteredList,
      filteredDataLong: isfilteredDataLong
    })

  }

  /* LOAD READER RANKING */
  sortByKey (array, key, ascdesc) {
    return array.sort((a, b) => {
      let x = (ascdesc === 'asc') ? b[key] : a[key]
      let y = (ascdesc === 'asc') ? a[key] : b[key]
      return -((x < y) ? -1 : ((x > y) ? 1 : 0))
    })
  }

  expandCard (e) {
    const targetRow = e.target.closest('.nnd-tile')
    if (!targetRow) return
    
    const targetSection = targetRow.querySelector('.nnd-tile-content')
    const targetImage = targetRow.querySelector('.nnd-sched-tile')
    if (!targetSection || !targetImage) return
    
    const targetSectionHeight = targetSection.offsetHeight
    const targetImageHeight = targetImage.offsetHeight
    const existActiveRow = document.querySelector(".nnd-tile.nnd-active")

    if ( targetRow === this.state.activeCard ) {
      targetRow.classList.toggle(`nnd-active`)
      this.setState({
        activeCard: null
      }, function () {
        targetRow.style.height = targetImageHeight + 'px'
      });

    } else {
      if (existActiveRow) {
        const existActiveRowImage = existActiveRow.querySelector('.nnd-sched-tile')
        if (existActiveRowImage) {
          const existActiveRowImageHeight = existActiveRowImage.offsetHeight
          existActiveRow.classList.toggle(`nnd-active`)
          existActiveRow.style.height = existActiveRowImageHeight + 'px'
        }
      }

      this.setState({
        activeCard: targetRow
      }, function () {
        const currentCard =  this.state.activeCard
        currentCard.classList.toggle(`nnd-active`)
        currentCard.style.height = targetImageHeight + 'px'
        targetRow.style.height = ( targetSectionHeight + targetImageHeight )+ 'px'
      });

    }
  }

  render() {
    const itemTiles = (typeof this.state.filteredData !== 'undefined') ? this.state.filteredData.map((item) => {
      if (typeof this.state.data !== 'undefined') {
        return (

          item.teamHome == 'BYE' || item.teamHome == 'HEADER'
          ?
            <div key={item.id} className={`nnd-tile nnd-${item.teamHome} nnd-round-${item.round}`}>
              <div className='nnd-sched-tile'>
                <div className="nnd-cta">
                  <div className="nnd-cta-item">
                    <span className="nnd-cta-game">
                      {item.teamHome == 'BYE'
                      ?
                      <span className="nnd-cta-round-team bye">
                        <span className="nnd-cta-round">R{ item.round } {/*<span className="nnd-cta-roundBox">{ item.round }</span>*/}</span>
                        <span className="nnd-cta-byeTitle">Bye: { item.bye }</span>
                      </span>
                      :
                      <span className="nnd-cta-round-team nnd-roundHeader">
                        <h4 className="nnd-cta-round">Round { item.round }</h4>
                      </span>
                      }

                    </span>
                  </div>
                </div>
              </div>
            </div>
          :
            <div key={item.id} className={`nnd-tile nnd-round-${item.round}`} onClick={(e) => { this.expandCard(e); /*e.preventDefault()*/ }} >
              <div className='nnd-sched-tile'>
                <div className="nnd-cta">
                  <h4 className="nnd-cta-item">
                    <span className="nnd-cta-game">
                      <span className="nnd-cta-round-team">
                        <span className="nnd-cta-round">R{item.round} {/*<span className="nnd-cta-roundBox">{ item.round }</span>*/}</span>
                        <span className="nnd-cta-gameTitle">{ item.teamHome } vs { item.teamAway }<span className="nnd-sport-gameTitleExtra">, { item.date }, { item.time }</span></span></span>
                    </span>
                  </h4>
                  <div className="nnd-cta-icon" data-index={item.id}>
                    <div className="nnd-cta-icon_plus"></div>
                    <div className="nnd-cta-icon_plus_vertical"></div>
                  </div>
                </div>
              </div>
              <div className='nnd-sched-tile-expanded'>
                <div className="nnd-tile-content">
                  <div className="nnd-tile-content-inner">   
                    <div className="nnd-tile-text" >
                      <div className="nnd-details">
                        <div className="nnd-matchTeams">
                          <div className="nnd-matchTeam nnd-matchTeam1">
                            <div className={`nnd-teamLogo ${item.teamHomeClass}`}></div>
                            <h3>{ item.teamHome }</h3>
                          </div>
                          <div className="nnd-vs">VS</div>
                          <div className="nnd-matchTeam nnd-matchTeam2">
                            <div className={`nnd-teamLogo ${item.teamAwayClass}`}></div>
                            <h3>{ item.teamAway }</h3>
                          </div>
                        </div>
                        <h5>{ item.date } - { item.time }</h5>
                        {item.venue && ( <p><span>Venue:</span> {item.venue}</p> )}
                        {item.bye && ( <p>{item.bye}</p> )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
        )
      }
    }) : ''

    const siteDomain = this.state.siteDomain
    const isActiveCard = this.state.activeCard
    const isMobApp = this.state.isMobApp

    return (
      <div id="nnd-container" className={`nnd-site-${siteDomain ? siteDomain : ""} nnd-app-${isMobApp ? isMobApp : ""} `}>
        <div className="nnd-headerMain">
          <h3>AFL Schedule 2026</h3>
        </div>

        <div className="nnd-navigation">
          <Select 
            onChange={event => this.changeRound(event)} 
            className="nnd-round" 
            classNamePrefix="nnd-select" 
            // isMulti 
            options={this.state.roundOptions} 
            // placeholder={'All Dates'}
            value={this.state.selectedRound}
          />
              
          <Select 
            onChange={event => this.changeSport(event)} 
            className="nnd-team" 
            classNamePrefix="nnd-select" 
            options={this.state.teamOptions} 
            value={this.state.selectedTeam}
          />
          
          <Select 
            onChange={event => this.changeVenue(event)} 
            className="nnd-venue" 
            classNamePrefix="nnd-select" 
            options={this.state.venueOptions} 
            value={this.state.selectedVenue}
          />
        </div>
        
        <div className="nnd-cont-main-wrap" data-long={ this.state.filteredDataLong }>
          <div className="nnd-cont-main" ref="scroller">
            <div className={isActiveCard !== null ? 'nnd-tiles nnd-activeCard' : 'nnd-tiles'} >
              {itemTiles.length
              ?
                itemTiles
              :
                <div className="nnd-tiles">
                  <div className="nnd-noTile-message">No games found</div>
                </div>
              }
            </div>
          </div>
        </div>

        <div className="nnd-footer"></div>

      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js